import React from 'react';
import { Route } from 'react-router-dom';
import BlogList from './BlogList';
import BlogPost from './BlogPost';

const render_blogs = () => {
  return (
    <>
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:id" element={<BlogPost />} />
    </>
  );
};

export default render_blogs;
